module.exports = __webpack_public_path__ + "static/media/anime_kyo_female.19ccf143.jpg";